<template>
  <div class="container posts pt-5 pb-5">
    <h1>Posts</h1>
   <div class="row">
      <div class="col-md-4" v-for="post in posts" :key="post.id">
        <div >
          <div class="card">
            <img
              class="card-img-top"
              src="https://via.placeholder.com/150"
              alt="Card image cap"
            />
            <div class="card-body">
              <h5 class="card-title">{{ post.title.rendered }}</h5>
              <div class="card-text" v-html="post.content.rendered">
                {{ post.content.rendered }}
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  mounted() {
    this.getPosts();
  },

  data() {
    return {
      postsUrl: "https://headless.monokollektiv.com/wp-json/wp/v2/posts/",
      posts: [],
      postsData: {
        per_page: 10,
        page: 1,
      },
    };
  },
  methods: {
    getPosts() {
      axios
        .get(this.postsUrl, { params: this.postsData })
        .then((response) => {
          this.posts = response.data;
          this.configPagination(response.headers);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>